var React = require('react');

function Date (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".aac73e7b-e529-49f8-877d-457a1f81ca2b{fill:#555;}")),React.createElement("g",{"id":"acb1ff83-3321-4219-9921-aa96691353db","data-name":"Layer 2","key":1},React.createElement("g",{"id":"bc4386a8-6d3d-41e3-9bd0-534a90b62349","data-name":"Layer 1"},React.createElement("path",{"className":"aac73e7b-e529-49f8-877d-457a1f81ca2b","d":"M14,11H9v5h5ZM13,0V2H5V0H3V2H2A1.991,1.991,0,0,0,.01,4L0,18a2,2,0,0,0,2,2H16a2.006,2.006,0,0,0,2-2V4a2.006,2.006,0,0,0-2-2H15V0Zm3,18H2V7H16Z"})))]);
}

Date.defaultProps = {"width":"18","height":"20","viewBox":"0 0 18 20"};

module.exports = Date;

Date.default = Date;
